import React from "react"

import "./styles.scss"

const GoBackButton = ({text, goBackFunction,isMicrosoftEdgeBrowser}) =>{

    return <div onClick = {() => goBackFunction()} className={isMicrosoftEdgeBrowser ? "goBackObjectiveDetailsPage microsoftEdgeBrowser" : "goBackObjectiveDetailsPage"}>{text}</div>
}

export default GoBackButton